import { render, staticRenderFns } from "./ShareFileView.vue?vue&type=template&id=6da76b26&scoped=true&"
import script from "./ShareFileView.vue?vue&type=script&lang=js&"
export * from "./ShareFileView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=6da76b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da76b26",
  null
  
)

export default component.exports